import isDeployError from './isDeployError';

// One-time silent reload after a new deploy. We guard on a sessionStorage
// timestamp so that if the reload does NOT fix the problem (e.g. a genuine
// bug, not a stale bundle) we don't get stuck in an infinite reload loop and
// instead let the UI render its fallback.
// ----------------------------------------------------------------------

const RELOAD_KEY = 'app:auto-reloaded-at';
const RELOAD_COOLDOWN = 10 * 1000; // 10s
let handlersRegistered = false;

export function tryDeployReload() {
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last > RELOAD_COOLDOWN) {
      window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
      return true;
    }
  } catch (e) {
    // sessionStorage can throw in private mode / sandboxed iframes — just skip.
  }
  return false;
}

// Catches chunk-load failures that happen OUTSIDE of React's render cycle
// (e.g. prefetching a route, an import() from an event handler). The React
// error boundary only sees errors thrown during render, so this covers the
// rest and keeps stale-deploy sessions from white-screening.
export function registerDeployReloadHandler() {
  // React StrictMode/HMR or repeated application setup must not install
  // duplicate listeners and attempt multiple reloads for the same failure.
  if (handlersRegistered) return;
  handlersRegistered = true;

  window.addEventListener(
    'error',
    (event) => {
      // Resource loading failures often have no event.error. Pass the full event
      // so isDeployError can inspect its message and failed script/link target.
      if (isDeployError(event)) tryDeployReload();
    },
    true
  );

  window.addEventListener('unhandledrejection', (event) => {
    if (isDeployError(event)) tryDeployReload();
  });
}
